<template>
  <a-result title="404" :sub-title="`抱歉，您访问的页面不存在，${second}秒后返回首页。`">
    <template #icon>
      <sass-icon type="hi-zanwuxinhao" style="font-size: 425px;" />
    </template>
    <template #extra>
      <a-button type="primary" @click="toHome">
        回到首页
      </a-button>
    </template>
  </a-result>
</template>

<script>
export default {
  name: 'Exception404',
  data () {
    return {
      second: 3
    }
  },
  methods: {
    toHome () {
      window.location.replace(window.location.origin + '/ucs/main_home')
    }
  },
  mounted () {
    const timer = setInterval(() => {
      --this.second
      if (this.second < 0) {
        clearInterval(timer)
        this.toHome()
      }
    }, 1000)
  }
}
</script>
